import { enter, leave } from 'el-transition'
import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = [
    'errorMessage',
    'form',
    'pendingOverlay',
    'successfulOverlay',
  ]

  static values = {
    documentId: String,
    errorMessage: String,
    genericError: String,
    status: String,
  }

  errorMessageValueChanged(value, previousValue) {
    if (value !== '') {
      this.errorMessageTarget.innerHTML = this.errorMessageValue
      enter(this.errorMessageTarget)
    } else if (previousValue !== undefined && value === '') {
      this.errorMessageTarget.innerHTML = ''
      leave(this.errorMessageTarget)
    }
  }

  statusValueChanged() {
    switch (this.statusValue) {
      case 'error':
        leave(this.pendingOverlayTarget)
        break
      case 'pending':
        enter(this.pendingOverlayTarget)
        break
      case 'success':
        leave(this.pendingOverlayTarget)
        enter(this.successfulOverlayTarget)
        break
      default:
    }
  }

  async submit() {
    this.statusValue = 'pending'
    this.errorMessageValue = ''

    let response

    try {
      response = await post(
        this.formTarget.action,
        {
          body: new FormData(this.formTarget),
          responseKind: 'json',
        },
      )
    } catch (error) {
      this.errorMessageValue = this.genericErrorValue
      this.statusValue = 'error'
      return
    }

    if (response.ok) {
      const data = await response.json
      this.documentIdValue = data.id
      this.statusValue = 'success'
    } else if (response.unprocessableEntity) {
      const data = await response.json
      this.errorMessageValue = data.error
      this.statusValue = 'error'
    } else {
      this.errorMessageValue = this.genericErrorValue
      this.statusValue = 'error'
    }
  }
}
